define([
	"dojo/_base/declare",
	"underscore",
	"csi/action/Manage",
	"csi/xml"
], function(declare,_,Manage,xml) {

	return declare(Manage, {
		checkNodeAccess: function(/*Node*/node,  /*Context*/ctx) {
			// summary: crew will always have NoDelete flag, so need to skip check for that

			// C8-19113: if node is a Style and has an AssignedAgent, the Crew toggle should be true and read only
			if (!_.isEmpty(node.AssignedAgents)) {
				return false;
			} else {
				return xml.nodeHasRight(node, xml.RIGHT_ADMIN) && !xml.nodeHasFlag(xml.NODE_FLAG_FROZEN);
			}
		}
	});
});
